import { http } from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    sendResetLinkEmail(username, email) {
        return http.post(`/api/password/email`, {username: username, email: email}).then(getData);
    }

};



// WEBPACK FOOTER //
// ./src/services/Auth/PasswordEmailController.js